<template>
  <div>
    <div class="satbar" :class="{sm: small}">
      <div v-for="s in segs" :key="s.b" v-tip="s.tip" class="satseg" :style="{width: s.p + '%', background: s.c}">
        <span v-if="s.p >= (small ? 9 : 6)" class="num-ltr">{{ Math.round(s.p) }}%</span>
      </div>
    </div>
    <div v-if="legend" class="sd-legend">
      <span v-for="s in segs" :key="s.b" class="lg"><span class="sw" :style="{background: s.c}" />{{ s.label }} <b v-if="counts" class="tnum" style="color:var(--sd-ink)">{{ compact(s.v) }}</b></span>
    </div>
  </div>
</template>
<script>
/* Five-bucket satisfaction band. buckets: { VS, S, NU, D, VD } counts */
import { BUCKETS, BUCKET_C, compact, fmt, pctHtml, esc } from '../../lib/format.js'
import { sdMixin } from '../../store.js'
export default {
  name: 'SdSatBar',
  mixins: [sdMixin],
  props: { buckets: { type: Object, required: true }, small: Boolean, legend: Boolean, counts: { type: Boolean, default: true } },
  computed: {
    segs() {
      const tot = Object.values(this.buckets).reduce((a, b) => a + (b || 0), 0) || 1
      return BUCKETS.map(([k, b]) => { const v = this.buckets[b] || 0, p = v / tot * 100; return { b, v, p, c: BUCKET_C[b], label: this.t(k), tip: `<b>${esc(this.t(k))}</b><br>${fmt(v)} · ${pctHtml(Math.round(p * 10) / 10)}` } })
    },
  },
  methods: { compact },
}
</script>
